import { createSelector } from 'reselect'

export default createSelector(
	[ state => state.poll.timer ],
	timer => timer
)
